import React, { useRef, useState } from 'react'
import { Icon, Popup } from 'semantic-ui-react'

export interface LogResponse {
  Service: string | null
  Code: number
  Err: string
  Base64Log: string | null
  Trigger: string
  Stack: string[]
}

function formatLog(log: string | null) {
  if (!log) return log

  let decodedLog = ''

  try {
    decodedLog = atob(log)
  } catch {
    // do nothing the string is not base64 decoded.
    return log
  }

  try {
    const parsedLog = JSON.parse(decodedLog)

    log = JSON.stringify(parsedLog, null, 2)
  } catch {
    // do nothing the string is not parsable JSON.
  }
  return log
}

function formatStack(stack: string[]) {
  if (!stack) return stack

  return stack.join('\n')
}

const LambdaErrorCell: React.FC<{ content: LogResponse }> = props => {
  const log = formatLog(props.content.Base64Log)
  const stack = formatStack(props.content.Stack)
  const triggerRef = useRef<HTMLDivElement>(null)
  const [popupPosition, setPopupPosition] = useState<string>('bottom right')

  const handleOpen = () => {
    if (triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect()
      const windowWidth = window.innerWidth

      if (rect.left < windowWidth / 2) {
        setPopupPosition('bottom left')
      } else {
        setPopupPosition('bottom right')
      }
    }
  }

  return (
    <Popup
      wide
      position={popupPosition as any}
      onOpen={handleOpen}
      content={
        <>
          <h4>
            {props.content.Trigger}&nbsp;&nbsp;({props.content.Code})
          </h4>
          <pre className='cbgms-grid__lambda_error-cell'>
            <code className='cbgms-grid__lambda_error-cell-code'>{log}</code>
          </pre>
          <h4>{props.content.Service}</h4>
          <pre className='cbgms-grid__lambda_error-stack'>
            <div>{stack}</div>
          </pre>
        </>
      }
      on='click'
      trigger={
        <div ref={triggerRef} style={{ display: 'inline-block' }}>
          <Icon fitted link name='code' />
        </div>
      }
    />
  )
}

LambdaErrorCell.displayName = 'LambdaErrorCell'

export default LambdaErrorCell
